import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";

function Counter({ target, suffix = "", duration = 2 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const increment = target / (duration * 60);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 1000 / 60);
    return () => clearInterval(timer);
  }, [inView, target, duration]);

  return (
    <span ref={ref}>
      {count}{suffix}
    </span>
  );
}

const stats = [
  { number: 15, suffix: "+", label: "Años de experiencia" },
  { number: 200, suffix: "+", label: "Proyectos entregados" },
  { number: 100, suffix: "%", label: "Clientes satisfechos" },
  { number: 50, suffix: "M+", label: "MXN en obra ejecutada" },
];

export default function StatsSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A] relative overflow-hidden" data-testid="stats-section">
      {/* Decorative grid */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: "linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)",
        backgroundSize: "80px 80px",
      }} />

      <div ref={ref} className="max-w-[1800px] mx-auto relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="text-center md:text-left"
              data-testid={`stat-card-${i}`}
            >
              <p
                className="text-5xl md:text-6xl lg:text-7xl font-light text-white tracking-tight"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                <Counter target={stat.number} suffix={stat.suffix} />
              </p>
              <motion.div
                initial={{ scaleX: 0 }}
                animate={inView ? { scaleX: 1 } : {}}
                transition={{ duration: 0.8, delay: 0.5 + i * 0.1 }}
                className="h-px bg-white/10 my-4 origin-left"
              />
              <p className="text-neutral-500 text-sm tracking-wide font-light">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
